import Modal from '../../../../components/Modal';
import PropTypes from 'prop-types';
import { React, useState } from 'react';
import CustomToast from '../../../../components/Toast';
import { useSendPodioFeedbackMutation } from '../../../../features/authentication/authApiSlice';

const HelpRequest = ({
  modalData,
  setModalData,
  modalSubmissionType,
  setFeedbackSent,
  onSubmitSuccess,
  onRequestClose
}) => {
  const [contactInfo, setContactInfo] = useState('');
  const [issueDescription, setIssueDescription] = useState('');
  const pathUrl = location.pathname;
  const deviceInfo = navigator.platform;
  const userAgent = navigator.userAgent;
  const [sendPodioFeedback, { isLoading }] = useSendPodioFeedbackMutation();
  let labels = {};

  switch (modalSubmissionType?.toLowerCase()) {
  case 'help':
    labels = {
      header: 'Help Request',
      textAreaLabel: 'Issue',
      instructions:
          'Please enter your issue below (limit of 2000 characters). When finished, press the Submit button to send your issue to the Castle Support Team. Someone will contact you as soon as possible. If your issue is urgent, please contact support at 1-800-345-7606.'
    };
    break;
  case 'feedback':
    labels = {
      header: 'Suggestion / Feedback',
      textAreaLabel: 'Suggestion',
      instructions:
          'Please enter your suggestion or feedback below (limit of 2000 characters). When finished, press the Send button to send your suggestion to Castle Learning or press Cancel to exit.'
    };
    break;
  default:
    labels = {
      header: 'Help Request',
      textAreaLabel: 'Issue',
      instructions:
          'Please enter your suggestion or feedback below (limit of 2000 characters). When finished, press the Send button to send your suggestion to Castle Learning or press Cancel to exit.'
    };
    break;
  }

  let browserName;
  let browserVersion;

  if (userAgent.match(/chrome|chromium|crios/i)) {
    browserName = 'Chrome';
    browserVersion = userAgent.match(/(?:Chrome|Chromium|CriOS)\/(\d+(\.\d+)?)/i)[1];
  } else if (userAgent.match(/firefox|fxios/i)) {
    browserName = 'Firefox';
    browserVersion = userAgent.match(/(?:Firefox|FxiOS)\/(\d+(\.\d+)?)/i)[1];
  } else if (userAgent.match(/safari/i)) {
    browserName = 'Safari';
    browserVersion = userAgent.match(/Version\/(\d+(\.\d+)?)/i)[1];
  } else if (userAgent.match(/opr\//i)) {
    browserName = 'Opera';
    browserVersion = userAgent.match(/OPR\/(\d+(\.\d+)?)/i)[1];
  } else if (userAgent.match(/edg/i)) {
    browserName = 'Edge';
    browserVersion = userAgent.match(/Edg\/(\d+(\.\d+)?)/i)[1];
  } else {
    browserName = 'No Browser detection';
    browserVersion = 'No Browser version detection';
    console.log(browserName);
    console.log(browserVersion);
  }

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateTelephone = (telephone) => {
    const telephoneRegex = /^(\d+-?){10,}$/;
    return telephoneRegex.test(telephone);
  };

  const sendHelpRequest = async () => {
    if (!isLoading) {
      if (!validateEmail(contactInfo) && !validateTelephone(contactInfo)) {
        CustomToast('The contact information provided is invalid.', 'warning');
        return;
      }

      if (!issueDescription || issueDescription.length > 2000) {
        CustomToast(
          !issueDescription ? 'The description is required.' : 'The issue description is too long.',
          'warning'
        );
        return;
      }

      const options = {
        from: contactInfo,
        subject: null,
        body: issueDescription,
        page: pathUrl,
        tags: null,
        device: deviceInfo,
        browser: browserName,
        version: browserVersion
      };

      if (modalSubmissionType?.toLowerCase() === 'help') {
        options.subject = 'Help Request';
        options.tags = ['helpSubmission'];
      } else {
        options.subject = 'New Castle Comments/Suggestions';
        options.tags = [''];
      }

      try {
        await sendPodioFeedback(options).unwrap();
        CustomToast(
          `${modalSubmissionType?.toLowerCase() === 'help' ? 'Help Request' : 'Feedback'} Submitted.`,
          'success'
        );
        setFeedbackSent(true);
        await onSubmitSuccess?.();
        setModalData(false);
      } catch (error) {
        CustomToast(
          `${modalSubmissionType?.toLowerCase() === 'help' ? 'Help Request' : 'Feedback'} Failed.`,
          'error'
        );
        console.log(error);
      } finally {
        setContactInfo(null);
        setIssueDescription(null);
      }
    }
  };

  const assignContactInfo = (event) => {
    setContactInfo(event.target.value);
  };

  const assignIssueDescription = (event) => {
    setIssueDescription(event.target.value);
  };

  const modelCloseHandler = () => {
    setModalData(false);
    onRequestClose?.();
    setContactInfo(null);
    setIssueDescription(null);
  };

  return (
    <Modal
      contentWidth="800px"
      isOpen={modalData}
      titleName={labels.header}
      onClose={modelCloseHandler}>
      <div className="form-label justify-text">
        {labels.instructions}

        <div className="mt-3">
          <label className="form-label">Contact Email or Phone</label>
          <input
            type="text"
            className="form-control"
            placeholder=" "
            name="contactInfo"
            id="contactInfo"
            value={contactInfo}
            onChange={assignContactInfo}
            required
            style={{ cursor: 'unset' }}
          />
        </div>

        <div className="mt-3">
          <div className="d-flex flex-row justify-content-between align-items-end">
            <label className="form-label">{labels.textAreaLabel}</label>
            <span className="text-color">
              <span className={`${issueDescription?.length <= 2000 ? ' text-color' : ' error'}`}>
                {issueDescription?.length}
              </span>
              {' / 2000'}
            </span>
          </div>
          <textarea
            type="text"
            className="form-control textarea-lg"
            placeholder=" "
            name="issueDescription"
            id="issueDescription"
            value={issueDescription}
            onChange={assignIssueDescription}
            required
            style={{ cursor: 'unset' }}
          />
        </div>
        <div className="d-flex justify-content-end mt-3 gap-3 align-items-center">
          <button className="btn btn-castleGray print-btn" onClick={modelCloseHandler}>
            Cancel
          </button>
          <button
            className="btn btn-castleRed print-btn"
            onClick={sendHelpRequest}
            disabled={isLoading}>
            {modalSubmissionType?.toLowerCase() === 'help' ? 'Submit' : 'Send'}
          </button>
        </div>
      </div>
    </Modal>
  );
};

HelpRequest.propTypes = {
  modalData: PropTypes.bool,
  setModalData: PropTypes.func,
  modalSubmissionType: PropTypes.string,
  setFeedbackSent: PropTypes.func,
  onSubmitSuccess: PropTypes.func,
  onRequestClose: PropTypes.func
};

export default HelpRequest;
